/**
 * Empty function, used as a default value for callbacks or mocking purposes
 */
//eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() {}

export default noop;
